import { getRoleInfo, getUserInfo, getRoleMoudules, getUserMenus } from "@/utils/auth"
import router from "@/router"
import { path } from "d3"
export default {
  inserted(el, bindling) {
    //bindling.value为指令的绑定值
    let perVal = bindling.value
    if (bindling.value) {
      //hasPermision this.checkValidate是我们项目的自定义的检验权限码的方法
      // 校验的方法可以自由发挥

      let hasPermision = tjtfPermisionCheck(perVal)
      //没有权限就先隐藏此元素吧
      if (!hasPermision) {
        el.style.display = "none"
      }
    }
  }
}

const tjtfPermisionCheck = (perVal) => {
  var userinfo = JSON.parse(getUserInfo())
  //console.log("getUserInfo", userinfo.Id)
  if (userinfo.Id == "00000000-0000-0000-0000-000000000000") {
    return true
  }
  const userPerms = getUserPermissions()
  if (Array.isArray(perVal)) {
    return perVal.some((p) => userPerms.includes(p))
  }
  return userPerms.includes(perVal)
}

const getUserPermissions = () => {
  var paths = router.currentRoute.path.split("/")
  var path = "/" + paths[paths.length - 1]
  var userMenus = getUserMenus()
  if (!userMenus) {
    return []
  }
  var userMenus = JSON.parse(userMenus)
  var menuId = null
  userMenus.forEach((menu) => {
    if (path == menu.url) {
      menuId = menu.id
      return true
    }
  })

  var RoleMoudules = JSON.parse(getRoleMoudules())
  if (RoleMoudules.length > 0) {
    var module = RoleMoudules.find((m) => m.SecondId == menuId)
    if (module && module.permission_json) {
      return JSON.parse(module.permission_json)
    }
  }
  return []
}

const getMenuId = (path, children) => {
  var menuId = undefined
  children.forEach((child) => {
    if (child.Item && child.Item.Url == path) {
      menuId = child.Item.Id
      return true
    } else {
      if (menuId === undefined) menuId = getMenuId(path, child.Children)
    }
  })
  return menuId
}
